export default __webpack_public_path__ + "static/Quantico-Bold-6c65a6146ea8a5c381ec1e49c46fbdc3.ttf";